import classnames from 'classnames';
import { uniqueId } from 'lodash';

const FormField = (props) => {
	const { label, error } = props;
	const id = props.id ? id : uniqueId('dashui-field-');
	const labelProps = {
		htmlFor: id,
	};
	const formProps = Object.assign({}, props);
	delete formProps.label;
	delete formProps.error;

	const FormControl = props.formControl;

  delete formProps.formControl; // don't leak formControl to the input

	return (
		<div
			className={classnames('sui-form-field', {
				'sui-form-field-error': !!error,
			})}
		>
			<label className="sui-label" {...labelProps}>
				{label}
			</label>

			<FormControl {...formProps} />

			{!!error && (
				<span className="sui-error-message" role="alert">
					{error}
				</span>
			)}
		</div>
	);
};

export default FormField;
